import { Grid, IconButton as MuiIconButton, Typography } from '@material-ui/core';
import { Instagram, Language, LinkedIn, YouTube } from '@material-ui/icons';

import { appConstants } from '../domain/constant/app.constant';

const IconButton = MuiIconButton;

const sendToLink = (url) => window.open(url, '_blank');

const SocialMediaButtons = () => (
    <Grid alignItems="center" className="flex md:!justify-end">
        <Grid item>
            <IconButton onClick={() => sendToLink('https://www.instagram.com/facilita.juridico/')}>
                <Instagram className="text-[#376fd0] !size-5" />
            </IconButton>
        </Grid>
        <Grid item>
            <IconButton
                onClick={() => sendToLink('https://www.youtube.com/c/FacilitaJur%C3%ADdico')}
            >
                <YouTube className="text-[#376fd0] !size-5" />
            </IconButton>
        </Grid>
        <Grid item>
            <IconButton
                onClick={() =>
                    sendToLink('https://www.linkedin.com/company/facilita-jur%C3%ADdico')
                }
            >
                <LinkedIn className="text-[#376fd0] !size-5" />
            </IconButton>
        </Grid>
        <Grid item>
            <IconButton onClick={() => sendToLink('https://facilitajuridico.com/')}>
                <Language className="text-[#376fd0] !size-5" />
            </IconButton>
        </Grid>
    </Grid>
);

const ExternalRegisterFooter = () => (
    <div className="px-4 py-3 md:px-4 md:py-3 border-t border-gray-200 bg-[#F7F9FC]">
        <Grid
            spacing={2}
            className="flex flex-col items-center text-center gap-1 md:gap-2 md:flex-row md:justify-between md:text-left"
        >
            <Grid
                item
                xs={12}
                md={4}
                className="order-1 md:order-2 flex items-center justify-evenly md:justify-end w-full md:w-auto"
            >
                <button
                    type="button"
                    onClick={() => sendToLink(appConstants.whatsappSupportUrl)}
                    className="text-[#376fd0] font-medium !text-sm md:!text-sm md:!mr-4 content-center hover:underline"
                >
                    Precisa de ajuda?
                </button>

                <SocialMediaButtons />
            </Grid>

            <Grid item xs={12} md={4} className="order-2 md:order-1">
                <Typography className="text-gray-400 !font-normal !text-[10px] md:!text-sm !mb-0 md:mb-2 md:!ml-2">
                    © {new Date().getFullYear()} Facilita Jurídico - Todos os direitos reservados
                </Typography>
            </Grid>
        </Grid>
    </div>
);

export default ExternalRegisterFooter;
